import { FC } from 'react';
import { IFraudPatternEvidences, IFraudPatternFont } from 'src/ts/interfaces/listCheck';
import {
  FontCheckHowTo,
  FontDescriptorCard,
  FontDescriptorKey,
  FontDescriptorList,
  FontDescriptorName,
  FontDescriptorText,
  ListCheckEmptyState
} from '../../../../styles';
import { listCheckCopy } from '../../listCheckCopy';
import { evidencesFor } from '../advancedFraudTrendsModel';
import { descriptorParts } from './embeddedFontsModel';
import { PatternViewProps } from './types';

const copy = listCheckCopy.advancedFraudTrends;

const isMoved = (font: IFraudPatternFont) => font.flagged || (font.moved_keys ?? []).length > 0;

const EmbeddedFontsView: FC<PatternViewProps> = ({ pattern, evidence }) => {
  const found =
    evidence.status === 'success'
      ? evidencesFor(pattern, evidence.data as unknown as IFraudPatternEvidences)
      : null;
  const fonts = [...(found?.fonts ?? [])].sort((a, b) => Number(isMoved(b)) - Number(isMoved(a)));

  return (
    <div data-testid="advanced-fraud-trends-embedded-fonts">
      {evidence.status !== 'success' && (
        <ListCheckEmptyState>
          {evidence.status === 'idle' || evidence.status === 'loading'
            ? copy.loading
            : copy.unavailable}
        </ListCheckEmptyState>
      )}
      {evidence.status === 'success' && (
        <>
          <FontCheckHowTo>{copy.embeddedFontsHowTo}</FontCheckHowTo>
          {fonts.length ? (
            <FontDescriptorList>
              {fonts.map((font, index) => {
                const movedKeys = font.moved_keys ?? [];
                const moved = isMoved(font);
                return (
                  <FontDescriptorCard key={`${font.name}-${index}`} $moved={moved}>
                    <FontDescriptorName
                      $moved={moved}
                      data-testid="advanced-fraud-trends-font-name"
                    >
                      {font.name}
                    </FontDescriptorName>
                    <FontDescriptorText
                      data-testid="advanced-fraud-trends-font-descriptor"
                      data-moved={moved}
                    >
                      {descriptorParts(font.descriptor ?? '', movedKeys).map((part, index) =>
                        part.key ? (
                          <FontDescriptorKey
                            key={index}
                            $moved={part.moved}
                            data-testid={part.moved ? 'advanced-fraud-trends-moved-key' : undefined}
                          >
                            {part.text}
                          </FontDescriptorKey>
                        ) : (
                          part.text
                        )
                      )}
                    </FontDescriptorText>
                  </FontDescriptorCard>
                );
              })}
            </FontDescriptorList>
          ) : (
            <ListCheckEmptyState>{copy.noFonts}</ListCheckEmptyState>
          )}
        </>
      )}
    </div>
  );
};

export default EmbeddedFontsView;
